import React from "react";
import DEFAULT_LOGO from "@/assets/default_logo.png";
import DEFAULT_IMG from "@/assets/placeholder_grey.png";

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  type?: "img" | "logo" | "avatar";
}

const defaultImg = {
  img: DEFAULT_IMG,
  logo: DEFAULT_LOGO,
  avatar: DEFAULT_LOGO,
};

const Img: React.FC<IProps> = ({ className, src, type = "img", ...rest }) => {
  const validSrc = src || defaultImg[type];
  const onError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if ((e.target as HTMLImageElement).src !== defaultImg[type]) {
      (e.target as HTMLImageElement).src = defaultImg[type];
    }
  };
  return (
    <img className={className} src={validSrc} {...rest} onError={onError} />
  );
};

export default Img;
